import { useState, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient, useInfiniteQuery } from 'react-query';
import { getTransactions, getTransactionsTotal } from '../api';

export const useTransactions = (params?: any) => {
  const [transactions, setTransactions] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const { data: total, isLoading: totalLoading } = useQuery(['totalPrice', params], () =>
    getTransactionsTotal(params),
  );

  const { data, error, isLoading, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useInfiniteQuery(
      ['transactions', params],
      async ({ pageParam = 1 }) => {
        const res = await getTransactions({
          page: pageParam,
          ...params,
        });
        return res;
      },
      {
        cacheTime: 0,
        getNextPageParam: (lastPage, pages) => pages.length + 1,
      },
    );

  useEffect(() => {
    if (data) {
      const arr: any = data?.pages.map((item: any) => ({ ...item?.data?.data?.transactions }));
      setTransactions(Object.values(arr));
    }
  }, [data]);

  useEffect(() => {
    if (total) {
      setTotalPrice(total?.data.data.totalAmount);
    }
  }, [total]);

  return {
    transactions,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    totalPrice,
  };
};
